import React, { FC } from 'react'

import { IconCancelProps } from './IconCancel.types'
import * as Styled from './styles/IconCancel.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCancel: FC<IconCancelProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCancelProps['size'],
  isResponsive = false,
}: IconCancelProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m15.078 32.922 17.844-17.844m0 17.844L15.078 15.078'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2.167'
        />
        <path
          d='M42.984 24c0 10.484-8.5 18.984-18.984 18.984-10.484 0-18.984-8.5-18.984-18.984 0-10.484 8.5-18.984 18.984-18.984 10.484 0 18.984 8.5 18.984 18.984Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2.167'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCancel
